/* eslint-disable camelcase */
import React from 'react';
import { TableActions } from 'components';
import { familyConnectionTypeName } from 'enums';
import { detailsBtn } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var contactsListColumns = function contactsListColumns(onEdit) {
  return [{
    name: 'Име',
    value: 'first_name'
  }, {
    name: 'Презиме',
    value: 'middle_name'
  }, {
    name: 'Фамилия',
    value: 'last_name'
  }, {
    name: 'Град',
    value: 'city.name'
  }, {
    name: 'Телефон',
    value: 'phone'
  }, {
    name: 'Тип свързаност',
    render: function render(_ref) {
      var type = _ref.type;
      return ___EmotionJSX("span", null, familyConnectionTypeName[type]);
    }
  }, {
    name: 'Действие',
    render: function render(contact) {
      return ___EmotionJSX(TableActions, {
        mainAction: {
          onClick: function onClick() {
            return onEdit(contact);
          },
          leftIcon: {
            iconName: 'la la-pen',
            size: 20
          },
          css: detailsBtn
        }
      });
    },
    width: '90px'
  }];
};